import React, { PropsWithChildren } from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { MapPointIcon } from '@cp/ds/src/icons';
import { styled } from '@cp/ds/src/theme';
import { Tokens } from './const';

const AddressBox = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: Tokens.textColor(theme.palette['gray dark']),
}));

export const Address = (props: PropsWithChildren) => {
  return (
    <AddressBox component="div" variant="caption">
      <MapPointIcon fontSize="1.25rem" />
      <span>{props.children}</span>
    </AddressBox>
  );
};
